import React from 'react';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import Icon from '~components/icon';

interface ComponentProps {
  id: string;
  icons: FontAwesomeIconProps[];
  title?: string;
  className?: string;
}

const IconStack: React.FC<ComponentProps> = ({ id, icons, title, className }) => {
  const stackClassNames = classNames('fa-layers fa-fw', {
    [`${className}`]: className !== undefined,
  });

  return (
    <span key={id} className={stackClassNames} title={title}>
      {icons.map(({ icon, className, size, style, transform }, index) => (
        <Icon
          key={`${index}-${id}`}
          icon={icon}
          size={size}
          className={className}
          style={style}
          transform={transform}
        />
      ))}
    </span>
  );
};

export default IconStack;
